const stagger = document.querySelectorAll('.animate-stagger-in');
    
    if (stagger.length) {
      stagger.forEach((el) => {
        const staggers = el.children;
        gsap.from(staggers, {
          scrollTrigger: {
            trigger: staggers[0],
            start: 'top 80%',
            end: 'top 80%',
            once: true
          },
          y: 30,
          autoAlpha: 0,
          duration: 0.66,
          ease: 'sine',
          stagger: 0.175
        });
      });
    };

    const slideFromLeft = document.querySelectorAll('.animate-slide-from-left');

    if (slideFromLeft.length) {
      ScrollTrigger.batch(slideFromLeft, {
        start: 'top 75%',
        end: 'top 75%',
        once: true,
        markers: false,
        onEnter: batch => gsap.fromTo(batch,
          { autoAlpha: 0, x: -70 },
          { autoAlpha: 1, x: 0, opacity: 1, duration: 0.66 }
        )
      });
    }

    const slideFromRight = document.querySelectorAll('.animate-slide-from-right');

    if (slideFromRight.length) {
      ScrollTrigger.batch(slideFromRight, {
        start: 'top 75%',
        end: 'top 75%',
        once: true,
        markers: false,
        onEnter: batch => gsap.fromTo(batch,
          { autoAlpha: 0, x: 70 },
          { autoAlpha: 1, x: 0, opacity: 1, duration: 0.66 }
        )
      });
    }

    const slideUp = document.querySelectorAll('.animate-slide-up');

    if (slideUp.length) {
      ScrollTrigger.batch(slideUp, {
        start: 'top 75%',
        end: 'top 75%',
        once: true,
        markers: false,
        onEnter: batch => gsap.fromTo(batch,
          { autoAlpha: 0, y: 40 },
          { autoAlpha: 1, y: 0, opacity: 1, duration: 0.66 }
        )
      });
    }

    // image parallax
    gsap.utils.toArray(".animate-img-parallax").forEach(elem => {
      const tl2 = gsap.timeline({
        scrollTrigger: {
          scrub: 1,
          trigger: elem,
          start: "top 65%",
          end: "bottom top",
        },
      });
  
      tl2.to(elem, {
        y: -50,
      });
    });

//slideshow
var slideDelay = 4.5;
var slideDuration = .4;
var wrap = true;

var slides = document.querySelectorAll(".slide");
if (slides.length > 0 ) {
  // var prevButton = document.querySelector("#prevButton");
  // var nextButton = document.querySelector("#nextButton");
  var progressWrap = gsap.utils.wrap(0, 1);

  var numSlides = slides.length;

  gsap.set(slides, {
    xPercent: i => i * 100
  });

  var wrapX = gsap.utils.wrap(-100, (numSlides - 1) * 100);
  var timer = gsap.delayedCall(slideDelay, autoPlay);

  var animation = gsap.to(slides, {
    xPercent: "+=" + (numSlides * 100),
    duration: 1,
    ease: "none",
    paused: true,
    repeat: -1,
    modifiers: {
      xPercent: wrapX
    }
  });

  var proxy = document.createElement("div");
  var slideAnimation = gsap.to({}, {});
  var slideWidth = 0;
  var wrapWidth = 0;

  // var draggable = new Draggable(proxy, {
  //   trigger: ".slides-container",
  //   inertia: true,
  //   onPress: updateDraggable,
  //   onDrag: updateProgress,
  //   onThrowUpdate: updateProgress,
  //   snap: {     
  //     x: snapX
  //   }
  // });

  resize();

  window.addEventListener("resize", resize);

  // prevButton.addEventListener("click", function() {
  //   animateSlides(1);
  // });

  // nextButton.addEventListener("click", function() {
  //   animateSlides(-1);
  // });

  // function updateDraggable() {
  //   timer.restart(true);
  //   slideAnimation.kill();
  //   this.update();
  // }

  function animateSlides(direction) {   
    timer.restart(true);
    slideAnimation.kill();
    var x = snapX(gsap.getProperty(proxy, "x") + direction * slideWidth);
    
    slideAnimation = gsap.to(proxy, {
      x: x,
      duration: slideDuration,
      onUpdate: updateProgress
    });  
  }

  function autoPlay() {  
    // if (draggable.isPressed || draggable.isDragging || draggable.isThrowing) {
    //   timer.restart(true);
    // } else {
      animateSlides(-1);
    // }
  }

  function updateProgress() { 
    animation.progress(progressWrap(gsap.getProperty(proxy, "x") / wrapWidth));
  }

  function snapX(value) {
    let snapped = gsap.utils.snap(slideWidth, value);
    return wrap ? snapped : gsap.utils.clamp(-slideWidth * (numSlides - 1), 0, snapped);
  }

  function resize() {
    
    var norm = (gsap.getProperty(proxy, "x") / wrapWidth) || 0;
    
    slideWidth = slides[0].offsetWidth;
    wrapWidth = slideWidth * numSlides;
    
    wrap || draggable.applyBounds({minX: -slideWidth * (numSlides - 1), maxX: 0});
    
    gsap.set(proxy, {
      x: norm * wrapWidth
    });
    
    animateSlides(0);
    slideAnimation.progress(1);
  }
}